export default "__VITE_ASSET__BMbVyd_c__"